module.exports = __webpack_public_path__ + "img/mobile-header-1.b54125ef.png";